import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MedicalRecordService } from '../../core/services/medical-record.service';
import { MedicalRecord } from '../../core/models/medical-record.model';
import { Specialization } from '../../core/enums/specialization.enum';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ClinicDoctorProfileDto } from '../../core/models/clinic-doctor-profile.model';

@Component({
  selector: 'app-create-medical-record',
  imports: [ReactiveFormsModule],
  templateUrl: './create-medical-record.html',
  styleUrl: './create-medical-record.scss',
})
export class CreateMedicalRecord implements OnInit {
  medicalRecordForm: FormGroup;
  specializationOptions = Object.values(Specialization);
  isLoading = false;
  uploadError = '';
  attachments: string[] = [];
  clinicDoctors: ClinicDoctorProfileDto[] = [];

  patientId: string | undefined;
  constructor(
    private fb: FormBuilder,
    private medicalRecordService: MedicalRecordService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.medicalRecordForm = this.fb.group({
      medicalRecordDate: [new Date().toISOString().split('T')[0]],
      diagnosis: ['', Validators.required],
      notes: [''],
      attachments: [[]],
      doctorId: ['', Validators.required],
    });

    // Try to get patientId from router state or route param
    const nav = this.router.getCurrentNavigation();
    if (
      nav &&
      nav.extras &&
      nav.extras.state &&
      nav.extras.state['patient'] &&
      nav.extras.state['patient'].id
    ) {
      this.patientId = nav.extras.state['patient'].id;
    } else {
      this.route.paramMap.subscribe((params) => {
        this.patientId = params.get('patientId') || undefined;
      });
    }
  }

  ngOnInit(): void {
    const doctors = localStorage.getItem('clinicDoctors');
    if (doctors) {
      this.clinicDoctors = JSON.parse(doctors);
    }
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      // For demo, just store file names. Replace with upload logic as needed.
      this.attachments = Array.from(input.files).map((f) => f.name);
      this.medicalRecordForm.patchValue({ attachments: this.attachments });
    }
  }

  submit() {
    if (this.medicalRecordForm.invalid) {
      this.medicalRecordForm.markAllAsTouched();
      return;
    }
    if (!this.patientId) {
      this.uploadError = 'No patient selected.';
      return;
    }
    this.isLoading = true;
    const { doctorId, ...formValue } = this.medicalRecordForm.value;
    const record: MedicalRecord = formValue;
    this.medicalRecordService
      .createConsultationMedicalRecord(this.patientId, record, doctorId)
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate(['/dashboard/patients-view']);
        },
        error: () => {
          this.isLoading = false;
          this.uploadError = 'Failed to create medical record.';
        },
      });
  }
}
